import { Agent, getCheckoutSessionByHppId } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';

import { CheckoutSessionDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/entities/CheckoutSessionDetailEntity';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { useCache } from '@/hooks/requests/useCache';

export const useGetCheckoutSessionByHppId = (agent: Agent, hppId: string | undefined) => {
  if (!hppId) return { checkoutSession: undefined };

  const {
    state: { checkoutSessionEntity },
    actions: { updateApplicationContext },
  } = useApplicationContext();

  const {
    data: checkoutSession,
    loading,
    revalidate,
  } = useCache(getCheckoutSessionByHppId, {
    hppId,
  });

  useEffect(() => {
    if (checkoutSession) {
      const newCheckoutSessionEntity = new CheckoutSessionDetailEntity(checkoutSession, agent);
      updateApplicationContext({ checkoutSessionEntity: newCheckoutSessionEntity });
    }
  }, [checkoutSession, agent]);

  return {
    checkoutSessionEntity,
    checkoutSession,
    loading,
    revalidate,
  };
};
